import { Report } from "@/types/report";
import BigNumber from "bignumber.js";

const useEconomicOverview = ({
    incomings,
    outgoings,
    accounts,
}: {
    incomings: Report["incomings"];
    outgoings: Report["outgoings"];
    accounts: Report["accounts"];
}) => {
    const income = incomings.reduce((acc, current) => {
        return acc.plus(current.amount);
    }, BigNumber(0));
    const expense = outgoings.reduce((acc, current) => {
        return acc.plus(current.amount);
    }, new BigNumber(0));

    const { startBalance, endBalance } = accounts.reduce(
        (acc, current) => {
            return {
                startBalance: acc.startBalance.plus(current.startAmount),
                endBalance: acc.endBalance.plus(current.endAmount),
            };
        },
        { startBalance: new BigNumber(0), endBalance: new BigNumber(0) },
    );

    const getSafeNumber = (value: BigNumber) => {
        return value.abs().lt(1e-6) ? 0 : Number(value.toFixed(2));
    };

    return {
        income,
        expense,
        startBalance,
        endBalance,
        getSafeNumber,
    };
};

export default useEconomicOverview;
